import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SearchOutlined } from '@ant-design/icons';
// import Loading from "./Reusecomponent/Loading";

import Header from "../Header/Header";
import SideBar from "../SideBar/SideBar";
import './normalsearch.css'
import Footer from "../Footer/Footer";
import png1 from '../../assets/img/profiles/png 1.png'
import png11 from '../../assets/img/profiles/png 2.png'; import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import Selectdrop from "./Reusecomponent/Selectdrop";
import ProgramSearch from "./Reusecomponent/ProgramSearch"; import { DownloadOutlined } from '@ant-design/icons';
import Selectcourse from "./Reusecomponent/Selectcourse";
import { handelsearch, handprofileapi } from "../HttpRequest/afterlogin";
import University1 from "./Reusecomponent/University1";
import Country from "./Reusecomponent/Country";
import IntakeEducation from "./Reusecomponent/IntakeEducation";
import Basedonprofile from "./Reusecomponent/Basedonprofile";
import Document from "./Document";
import { applyUniversity, applyUniversityTakeIntake, getApplicationsWithId, updateApplication } from "../HttpRequest/applyapplication";
import { uploadApplicationDocuments } from "../HttpRequest/uploadDocuments";
import Popup from "./popupfiles/Popup/Popup";
import Pagination from "../pages/Base UI/Pagination";
import { Button, DatePicker, Select, Tooltip } from "antd";
import { Download } from "feather-icons-react/build/IconComponents";
import { cancelButton } from "./Base UI Elements/SweetAlert";
import ModelUpload from "../ModelUpload";
import { registersuccess } from "../SweetAlert/SweetAlert";
import Loading from "./Reusecomponent/Loading";




const Normalsearch = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [userdata, setuserdata] = useState({
    profileData: {},
    sarchprofiledata: []
  });
  const [apidata, setapidata] = useState([])
  const [files, setfile] = useState(null);
  const [queryfiledinput, setqueryfiledinput] = useState("");

  const [idnumber, setidnumber] = useState(true);
  const [program, setprogram] = useState(false);
  const [searchbar, setsearchbar] = useState(false);
  const [uploaddoc, setuploaddoc] = useState(false)
  const [searchbar0, setsearchbar0] = useState(false);
  const [handleprofile, sethandleprofile] = useState(false)
  const [cardselectbar, setcardselectbar] = useState(false);
  const [profiledatavisble, setprofiledatavisible] = useState(false)
  const [normalsearch, setnormalsearch] = useState(true);
  const [identifiers, setIdentifiers] = useState([]);
  const [normalsear, setnormalsear] = useState({
    lor1: true,
    lor2: true,
    sop: true,
    lor3: true,
    lor1name: "",
    lor2name: "",
    lor3name: "",
    sopname: ""
  })
  const [quicksearch, setquicksearch] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [uploads, setUploads] = useState([]);
  const [applicationId, setapplicationId] = useState("");
  const [masterId, setmasterId] = useState("");
  const [fileType, setFileType] = useState("");
  const [Error, setError] = useState("")
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    size: 10,
  });

  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [applyId, setApplyId] = useState('');
  const [loading, setLoading] = useState(false);

  const DataInfo = async () => {
    try {
      setLoading(true); 
      await new Promise((resolve) => setTimeout(resolve, 1000)); 
    } catch (error) {
      
    } finally {
      setLoading(false); 
      setprogram(true); 
      setcardselectbar(true);
      clearPagenation();
    }
  };

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i < 3; i++) {
    years.push(currentYear + i);
  }
  const currentMonth = new Date().getMonth();
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December", "Spring", "Fall", "Summer"];

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);

  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  // const documentFiles = [];
  const [documentFiles, setdocumentFiles] = useState([]);

  const handleUpload = (file) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const uploadInfo = {
        name: file.name,
        type: 'File',
        content: reader.result,
      };
      setUploads([...uploads, uploadInfo]);
    };
    reader.readAsDataURL(file);
  };

  const handleFileInputChange = (identifier) => (event) => {
    const files = event.target.files;
    console.log("files", event)
    console.log("files name", identifier)
    console.log("----", files)

    if (identifier === "lor1") {
      const files = event.target.files; console.log(files.name)
      setnormalsear({
        ...normalsear,
        lor1: false,
        lor1name: "lor1"
      })
    } else if (identifier === "lor2") {
      setnormalsear({
        ...normalsear,
        lor2: false,
        lor2name: "lor2"
      })
    } else if (identifier === "sop") {
      setnormalsear({
        ...normalsear,
        sop: false,
      })
    } else if (identifier === "lor3") {
      setnormalsear({
        ...normalsear,
        lor3: false,
        lor3name: "lor3"
      })
    }
    if (files && files.name) {
      const fileName = files.name;
      const lastDotIndex = fileName.lastIndexOf('.');
      if (lastDotIndex !== -1) {
        const fileExtension = fileName.substring(lastDotIndex + 1).toLowerCase(); console.log(fileExtension)

      } else {
        setError("File has no extension.");
      }
    } else {
      setError("File is undefined or has no name property.");
    }
    setIdentifiers([...identifiers, identifier]);
    console.log(fileType);
    for (let i = 0; i < files.length; i++) {
      handleUpload(files[i]);
    }
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        documentUploadMethod(files[i], identifier);
      }
    }
  };

  const [queryData, setQueryData] = useState({
    country: "",
    university: "",
    name: "",
    intake: ""
  });

  const [modalActive, setModalActive] = useState(false);
  const [pagedata, setPageData] = useState();
  const handlechange = (event) => {
    console.log('Event:', event);
    if (event && event.target) {
      const { value, name } = event.target;
      console.log('Value:', value);
      console.log('Name:', name);
      setcourseName((prevCourseName) => ({
        ...prevCourseName,
        [name]: value,
      }));
    }
  };
  const handleWriteClick = async () => {
  };

  const removethefile = (index) => {
    const updatedUploads = [...uploads];
    updatedUploads.splice(index, 1);
    setUploads(updatedUploads);
  };
  const downloadFile = (index) => {
    const fileToDownload = uploads[index];
    const downloadLink = document.createElement('a');
    downloadLink.href = fileToDownload.url;
    downloadLink.download = fileToDownload.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
  const setPageInfoData = (data) => {
    console.log("page data to parent-->", data);
    setPageInfo({
      page: data.currentPage,
      size: data.pageSize,
    });
  };

  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  const onChange = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    console.log('search:', value);
  };
  useEffect(() => {

    handleuniver();
  }, [pageInfo]);

  const addUniversityToWishList = (universityData) => {
    let userId = localStorage.getItem("id");
    console.log("applay itemdto-->", universityData);
    let application = {
      userId: userId,
      status: "application-requested",
      subStatus: "",
      masterDataEntityId: universityData.id
    };
    setmasterId(universityData.id);
    console.log("Application before update==>", application);
    applyUniversity(application).then((response) => {
      console.log(application);
      console.log("SingleuniversityeData response", response);
      if (response.request.status == 201 || response.request.status == 200) {
        console.log("Response of application==>", response);
        console.log("Response of applicationId==>", response.data.applicationId);
        setapplicationId(response.data.applicationId)
        setApplyId(response.data.id)
        setModalActive(true)
      } else if (response.request.status == 400) {
        alert(`${response.response.data}`)
      }
      else {
        console.log("something went wrong")
      }
    })
  }

  const UpdateApplicationStatus = (masterDataId, applicationId, status) => {
    let userId = localStorage.getItem("id");
    let application = {
      id: applyId,
      userId: userId,
      status: status,
      subStatus: "apply",
      masterDataEntityId: masterDataId,
      intake: selectedMonth,
      year: selectedYear,
      applicationId: applicationId
    };
    updateApplication(application.id, application).then((response) => {
      console.log(application);
      console.log("SingleuniversityeData response", response);
      if (response.request.status == 201 || response.request.status == 200) {
        setapplicationId(response.data.applicationId)
        registersuccess("Application submitted successfully with applicationId   " + response.data.applicationId);
        updateIntake();
        setModalActive(true)
      } else if (response.request.status == 400) {
        console.log("something went wrong", response.request)
      }
      else {
        console.log("something went wrong")
      }
    })
  }





  // const updateIntake = (intakeData) =>{
  //   intakeData.year = selectedYear;
  //   intakeData.intake = selectedMonth;
  //   applyUniversityTakeIntake(intakeData).then((response)=>{

  //     console.log("intake data ---->",intakeData);
  //   })
  // }


  const documentUploadMethod = (file, type) => {
    console.log("dum file ", file, type);
    const formData = new FormData();
    console.log("file name-->", formData);
    formData.append('file', file);

    const existingDocumentIndex = documentFiles.findIndex(doc => doc.type === type);
    if (existingDocumentIndex !== -1) {
      documentFiles[existingDocumentIndex] = {
        file: formData,
        type: type
      };
    } else {
      let fileObj = {
        file: formData,
        type: type
      };
      documentFiles.push(fileObj);
    }


    console.log("files added-->", documentFiles);
  };


  const submitApplyFinalDoccuments = async (masterDataId) => {
    console.log("...", documentFiles);
    if (documentFiles.length > 0) {
      try {
        const uploadPromises = documentFiles.map(async (doc) => {
          try {
            let userId = localStorage.getItem("id");
            console.log("appli Id -->", applicationId);
            const response = await uploadApplicationDocuments(userId, applicationId, doc.type, doc.file);
            console.log("file upload res-->", response);
            return response;
          } catch (error) {
            console.error("Error uploading file:", error);
            throw error;
          }
        });
        const responses = await Promise.all(uploadPromises);
        let status = 'application-requested';
        // if (documentFiles.length > 3) {
        //   status = 'apply'
        // } else {
        //   status = 'wishlist'
        // }
        UpdateApplicationStatus(masterId, applicationId, status)
        setdocumentFiles([]);
        setModalActive(false);
      } catch (error) {
        console.error("Error uploading files:", error);
      }
    } else {
      console.log("No document is selected")
    }
  };


  const closeModal = () => {
    setShowModal(false);
    console.log('close');
  };
  const openModal = () => {
    setShowModal(true);
    console.log('open');
  };
  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (handleprofile) {
  //       try {
  //         const response = await handprofileapi();
  //         console.log(response.data.data);
  //         setuserdata({
  //           ...userdata,
  //           sarchprofiledata: response.data.data
  //         })
  //         setprofiledatavisible(true)
  //       } catch (error) {
  //         console.error("Error fetching profile data:", error);
  //       }
  //     } else {
  //       console.log("profileapierror");
  //     }
  //   };

  //   fetchData();
  // }, [handleprofile])

  const clearPagenation = () => {
    setPageInfo({
      page: 0,
      size: 10,
    })
    handleuniver()
  }

  const handleuniver = async () => {
    console.log("searching-->", queryData);
    try {
      const response = await handelsearch(
        queryData.country,
        queryData.university,
        queryData.name,
        queryData.intake,
        pageInfo.page,
        pageInfo.size
      );
      console.log("search response api-->", response);
      setapidata(response.data);
      setPageData(response.data.metaData)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setqueryfiledinput({
      ...queryfiledinput,
      [name]: value,
    });
  };


  const imageSubmit = (event) => {
    const file = event.target.files[0];
    setfile(file);
  };

  const handleimageupload = async () => {
    const response = fileuploads(files);
    console.log("file", files);
    response.then((data) => {
      console.log(data);
      if (data.request.status == 200) {
        alert("success");
      } else {
        alert("error");
      }
    });
  };

  const handleFileUpload = (name) => {
    const fileInput = document.getElementById(name);
    if (fileInput) {
      fileInput.click();
    } else {
      console.error(`Element with id ${name} not found`);
    }
  };


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    console.log('Selected file-->', selectedFile);
  };

  console.log(identifiers);
  return (
    <>
      <div className="main-wrapper">

        <Header />


        <SideBar />

        <div className="page-wrapper ">

          <div>
            <div className={modalActive ? " imagespropety imageblue" : "imagespropety"}>
              <div className="pagecolum">
                <div className="card cardselectsearch_button cardselectbar">
                  <Link
                    to="/Normalsearch"
                    className={`cardselectsearch_buttonbg ${idnumber ? "idnumber" : null
                      }`}
                    onClick={() => {
                      setidnumber(true);
                      setsearchbar(false);
                      setsearchbar0(false);
                    }}
                  >
                    {" "}
                    <h6>Normal search</h6>
                  </Link>
                  <Link
                    to={{
                      pathname: '/addvancesearch',
                    }}
                    className={`cardselectsearch_buttonbg ${searchbar ? "searchbar" : null
                      }`}
                    onClick={() => {
                      setidnumber(false);
                      setsearchbar(true);
                      setsearchbar0(false);
                      setquicksearch(true);
                      setnormalsearch(false);
                    }}
                  >
                    <h6>Advance Search </h6>
                  </Link>{" "}

                </div>

                {uploaddoc ? <></> : <>
                  <Popup active={modalActive} setActive={setModalActive}>
                    <div className="model">
                      <div className="modal-dialog w-100 m-0 modal111">
                        <div className="modal-content modal-contentnormal">
                          <div className="modal-body">
                            <p ><strong>Upload Document </strong></p>
                            <span className="" style={{ fontSize: '12px', }}><strong>Submit the documents to apply for the selected program</strong></span>
                            <div className="mt-1">
                              <div className="normalsearch-cen">
                                {normalsear.sop && <div className="card  normalsearchcard" >
                                  <strong> <span >SOP</span></strong>
                                  <div >
                                    <label className="imagedocument documen btn btn btn-success mt-2  normalbtn-success">
                                      <input
                                        type="file"
                                        onChange={handleFileInputChange("sop")}
                                        multiple
                                        style={{ display: 'none' }}
                                      />
                                      Upload   <i class="fa-solid fa-arrow-up-from-bracket" style={{ marginLeft: '8px', }}></i>
                                    </label>
                                  </div>
                                </div>}
                                {normalsear.lor1 && <div className="card  normalsearchcard" >
                                  <strong> <span >LOR1</span></strong>
                                  <div >
                                    <label className="imagedocument documen btn btn btn-success mt-2  normalbtn-success">
                                      <input
                                        type="file"
                                        onChange={handleFileInputChange("lor1")}
                                        multiple
                                        style={{ display: 'none' }}
                                      />
                                      Upload   <i class="fa-solid fa-arrow-up-from-bracket" style={{ marginLeft: '8px', }}></i>
                                    </label>
                                  </div>
                                </div>}
                                {normalsear.lor2 && <div className="card  normalsearchcard" >
                                  <strong> <span >LOR2</span></strong>
                                  <div >
                                    <label className="imagedocument documen btn btn btn-success mt-2  normalbtn-success">
                                      <input
                                        type="file"
                                        onChange={handleFileInputChange("lor2")}
                                        multiple
                                        style={{ display: 'none' }}
                                      />
                                      Upload   <i class="fa-solid fa-arrow-up-from-bracket" style={{ marginLeft: '8px', }}></i>
                                    </label>
                                  </div>
                                </div>}
                                {normalsear.lor3 && <div className="card  normalsearchcard" >
                                  <strong> <span >LOR3</span></strong>
                                  <div >
                                    <label className="imagedocument documen btn btn btn-success mt-2  normalbtn-success">
                                      <input
                                        type="file"
                                        onChange={handleFileInputChange("lor3")}
                                        multiple
                                        style={{ display: 'none' }}
                                      />
                                      Upload   <i class="fa-solid fa-arrow-up-from-bracket" style={{ marginLeft: '8px', }}></i>
                                    </label>
                                  </div>
                                </div>}
                              </div>
                              {uploads.map((upload, index) => (
                                <div key={index} className="uplaoddocnormal mt-3">
                                  <div className="uploadcardiamges">
                                    {upload.name.toLowerCase().endsWith('.png') &&
                                      <img src="data:image/png;base64,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" alt="xlimages" className="normalxlimage" />}


                                    {upload.name.toLowerCase().endsWith('.jpeg') &&


                                      <img src="https://static.vecteezy.com/system/resources/previews/003/399/528/non_2x/modern-flat-design-of-jpeg-file-icon-for-web-free-vector.jpg" alt="xlimages" className="normalxlimage" />}

                                    {upload.name.toLowerCase().endsWith('.jpg') &&


                                      <img src="data:image/png;base64,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" alt="xlimages" className="normalxlimage" />}
                                    {upload.name.toLowerCase().endsWith('.pdf') &&


                                      <img src="https://www.pngguru.in/storage/uploads/images/PDF%20Icon%20free%20png_1695284057_1717843005.jpg" alt="xlimages" className="normalxlimage" />}
                                  </div>
                                  <div onClick={() => handleFileUpload('fileInputLor3')} className="uploadtext">{`Added ${upload.type} - ${upload.name}`}</div>
                                  <div className="uploadbuttongroup">

                                    <i class="fa-solid fa-download" onClick={() => downloadFile(index)}></i>
                                    <i class="fa-regular fa-pen-to-square"></i>
                                    <i class="fa-solid fa-trash" onClick={() => removethefile(index)}></i>
                                    <button className="btn btn-primary btnbuttondoc">
                                      {identifiers[index]}
                                    </button>
                                  </div>
                                </div>
                              ))}
                              <div className="normalsearch-model-button">
                                <p style={{ marginBottom: '0px', marginRight: '9px', }}><strong>Choose Intake, Year: </strong></p>
                                {/* <Select
                                  showSearch
                                  placeholder="Select Intake"
                                  optionFilterProp="children"
                                  onChange={onChange}
                                  onSearch={onSearch}
                                  filterOption={filterOption}
                                  options={[
                                    {
                                      value: 'Fall',
                                      label: 'Fall(AUG)',
                                    },
                                    {
                                      value: 'Spring',
                                      label: 'Spring(JAN)',
                                    },
                                    {
                                      value: 'Summer',
                                      label: 'Summer(MAY)',
                                    },
                                  ]}
                                  style={{ marginRight: '6px', }}
                                /> */}
                                <select id="monthSelect" name="month" className="form-control" value={selectedMonth} onChange={handleMonthChange} >
                                  <option value="">Select Month</option>
                                  {monthNames.map((month, index) => (
                                    <option key={index} value={month}>
                                      {month}
                                    </option>
                                  ))}
                                </select>

                                {/* <Select
                                  showSearch
                                  placeholder="Select Year"
                                  optionFilterProp="children"
                                  onChange={onChange}
                                  onSearch={onSearch}
                                  filterOption={filterOption}
                                  options={[
                                    {
                                      value: '2024',
                                      label: '2024',
                                    },
                                    {
                                      value: '2025',
                                      label: '2025',
                                    },
                                    {
                                      value: '2026',
                                      label: '2026',
                                    },
                                  ]}
                                /> */}
                                <select id="yearSelect" name="year" className="form-control" value={selectedYear} onChange={handleYearChange}>
                                  <option value="">Select Year</option>
                                  {years.map((year) => (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer  modal-footer1">
                            <div className="imagedocument">    <button
                              type="button"

                              className="bbtn btn-secondary footerbutton footerbutton3"
                              onClick={closeModal}


                            >Cancel
                            </button></div>
                            <label className="imagedocument documen documen1">
                              <input
                                type="file"
                                onChange={handleFileInputChange}
                                multiple
                                style={{ display: 'none' }}
                              />

                              Add Other document <i className="fa-solid fa-file-import"></i>
                            </label>
                            <button
                              type="button"

                              className="btn btn-secondary footerbutton"
                              onClick={submitApplyFinalDoccuments}
                            >Apply
                            </button>
                          </div>
                        </div>
                      </div>


                    </div>

                  </Popup>
                  {showModal && (
                    <div
                      className="modal">
                      <div className="overlay">
                        <div className="modal-dialog">
                          <div className="modal-content modal-contentnormal">
                            <div className="modal-body">
                              <div className="mt-1">
                                <div className="uplaoddocnormal mt-3 ">
                                  <div className="uploadcardiamges">
                                    <i class="fa-solid fa-file fs-3"></i>
                                  </div>
                                  <div className="uploadtext" onClick={handleFileUpload}>
                                    <strong style={{ color: 'gray', cursor: 'pointer' }}>Add Statement Of PurPose - SOP</strong></div>
                                  <div className="">

                                    <i class="fa-solid fa-upload" style={{ marginRight: '0.3rem', }}></i>
                                  </div>
                                  <input
                                    type="file"
                                    id="fileInput"
                                    style={{ display: 'none' }}
                                    onChange={(event) => documentUploadMethod(event, 'sop')}
                                  />
                                </div>

                                <div className="uplaoddocnormal mt-3 ">
                                  <div className="uploadcardiamges">
                                    <i class="fa-solid fa-file fs-3"></i>
                                  </div>
                                  <div className="uploadtext"><strong >Add Letter Of Recommendation - LOR01</strong></div>
                                  <div className="">

                                    <i class="fa-solid fa-upload" style={{ marginRight: '0.3rem', }}></i>
                                  </div>

                                </div>

                                <div className="uplaoddocnormal mt-3 ">
                                  <div className="uploadcardiamges">
                                    <i class="fa-solid fa-file fs-3"></i>
                                  </div>
                                  <div className="uploadtext"><strong >Add Letter Of Recommendation - LOR02</strong></div>
                                  <div className="">

                                    <i class="fa-solid fa-upload" style={{ marginRight: '0.3rem', }}></i>
                                  </div>

                                </div>
                                <div className="uplaoddocnormal mt-3 ">
                                  <div className="uploadcardiamges">
                                    <i class="fa-solid fa-file fs-3"></i>
                                  </div>
                                  <div className="uploadtext"><strong >Add Letter Of Recommendation - LOR03</strong></div>
                                  <div className="">

                                    <i class="fa-solid fa-upload" style={{ marginRight: '0.3rem', }}></i>
                                  </div>

                                </div>
                              </div>
                            </div>
                            {uploads.map((upload, index) => (
                              <div key={index} className="uplaoddocnormal mt-3">
                                <div className="uploadcardiamges">
                                  <i className="fa-solid fa-file fs-3"></i>
                                </div>
                                <div className="uploadtext">
                                  <strong>{`Add ${upload.type} - ${upload.name}`}</strong>
                                </div>
                                <div>
                                  <i className="fa-solid fa-upload" style={{ marginRight: '0.3rem' }}></i>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="modal-footer  modal-footer1">


                          <div className="imagedocument"><i class="fa-regular fa-image"></i> Photos</div>
                          <label className="imagedocument documen documen1">
                            <input
                              type="file"
                              onChange={handleFileInputChange}
                              multiple
                              style={{ display: 'none' }}
                            />
                            Add document <i className="fa-solid fa-file-import"></i>
                          </label>
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={closeModal}
                          >Close
                          </button>

                        </div>

                      </div>
                    </div>

                  )}


                </>}

                {normalsearch && <>  <div className="card cardnormatserach">
                  <div className="card-body card-narmal">
                    <Country userdata={queryData} setuserdata={setQueryData} placeholder="Select Country" className="cssfor" inputfiled="country" />
                    {/* <University1 placeholder="Select University" className="cssfor" inputfiled="university" /> */}
                    {/* <Selectcourse placeholder="Select Course" className="cssfor" /> */}
                    {/* <IntakeEducation placeholder="Select Intake" className="cssfor" inputfiled="course" /> */}
                    <div className="cardsearch" 
                         onClick={DataInfo}>
                            {loading ? (
                    <Loading />
                  ) : (
                          <i className="fas fa-search"></i>  )}
                        </div>
                       
                  </div>
                </div>
                  <div className="serachcheck">
                  </div>   {program && <> <div class="card cardprogram">
                    <div class="card-body cardprogrampadding">
                      <ProgramSearch searchresult={apidata} apply={addUniversityToWishList} refreshList={handleuniver} />
                      {pagedata?.totalPages > 1 && (
                        <Pagination pageResponce={pagedata} pagedataToParent={setPageInfoData} />
                      )}
                      {/* <div class="card cardtemplate">
                 <div class="card " style={{backgroundColor: 'gray',height:'100%', width:'100%'}}>
                   This is some text within a card body.
                 </div>
                 <div class=" cardtemplatetext"   style={{backgroundColor: '#D9E0FC',}}>
                  <div>
             
                   <div className="sameline " style={{justifyContent:'space-between'}}>
                   <h6 className="coursename">MS in Computer Science.</h6>
                 <div className="sameline normalsameline">
                  <h6><i class="fa-regular fa-heart"></i></h6>
                  <h6><i class="fa-solid fa-upload"></i></h6>
                  <h6 className="programapplybtn">Apply</h6>
                 </div>
                   </div>
                   <div className="sameline sameline1">
                    <p><i class="fa-solid fa-building-columns"></i> Northern Illinois University</p>
                    <p><i class="fa-solid fa-comments-dollar"></i> Yearly tuition fee :10$  <i class="fa-solid fa-download"></i></p>
                   </div>
                   <div className="sameline sameline1">
                    <p><i class="fa-solid fa-calendar-days"></i> Duration : 48months</p>
                    <p><i class="fa-solid fa-money-bills"></i>  United States of America</p>
                   </div>
                   <div className="sameline samelinee"  style={{gap:'5px'}}>
                    <p><i class="fa-solid fa-building-columns"></i> Intakes </p>
                    <span> <strong>  June 2022(open) | June 2022(open) | June 2022(open) </strong></span>

                   </div>
                   </div>

                   <div className="cardbox">
                    <div className="card normalcardbox">
                      <div className="diffline">
                      <p><strong>IELTS </strong></p>
                          <hr></hr>
                         <p><strong> 3.0 </strong></p>
                         </div>
                    </div>
                    <div className="card normalcardbox">
                      <div className="diffline">
                      <p><strong>IELTS </strong></p>
                          <hr></hr>
                         <p><strong> 3.0 </strong></p>
                         </div>
                    </div>

                    <div className="card normalcardbox">
                      <div className="diffline">
                      <p><strong>TOEFL </strong></p>
                          <hr></hr>
                         <p><strong> 2.0 </strong></p>
                         </div>
                    </div>
                    <div className="card normalcardbox">
                      <div className="diffline">
                      <p><strong>CELPIP </strong></p>
                          <hr></hr>
                         <p><strong> 2.0 </strong></p>
                         </div>
                    </div>

                   </div>
                 </div>
               </div> */}

                    </div>
                  </div></>}</>}    {profiledatavisble && <>  <Basedonprofile data={userdata.sarchprofiledata} /></>}


                {/* {quicksearch && <>  <div className="card cardnormatserach">
                <div className="card-body card-narmal ">

                  <div className="col">
                    <Selectdrop placeholder="Select Course" />
                    <Selectdrop placeholder="Select University" />
                  </div>

                  <div className="col">
                    <Selectdrop placeholder="Select Country" />
                    <Selectdrop placeholder="Select Course" />

                  </div>

                  <div className="col">
                    <Selectdrop placeholder="Select University" />
                    <Selectdrop placeholder="Select Country" />


                  </div>
                  <div className="cardsearch" onClick={() => { setprogram(true); setcardselectbar(true) }}><i className="fas fa-search"></i></div>
                </div>
              </div>   {program && <> <div class="card cardprogram">
                <div class="card-body cardprogrampadding">
                  <ProgramSearch />
                </div>
              </div></>}</>} */}

              </div>
            </div></div>

        </div >

        {/* Footer */}
        < Footer />
      </div >
      {/* /Main Wrapper */}
    </>
  );
};

export default Normalsearch;